import { combineReducers } from 'redux';
import { communicationsReducer } from './communications';
import { errorReducer } from '@entities/error';
export const accountReducer = combineReducers({
    communications: communicationsReducer,
    error: errorReducer
});
